import * as types from './types';
import { apiGetLocales, apiPostPrivacyFiles, apiGetPrivacyFiles } from './api';

export const setPrivacy = privacy => ( { type: types.PRIVACY__SET_PRIVACY, privacy } );

export const getPrivacy = id => dispatch => {
    return apiGetPrivacyFiles( id ).then( results => dispatch( setPrivacy( results ) ) );
};

export const clearPrivacy = () => ( { type: types.PRIVACY__CLEAR_PRIVACY } );
export const setLocaleOptions = options => ( { type: types.PRIVACY__SET_LOCALE_OPTIONS, options } );

export const getLocales = () => dispatch =>
    apiGetLocales().then( results => dispatch( setLocaleOptions( results.locales ) ) );

export const addFile = ( file, name ) => ( { type: types.PRIVACY__ADD_FILE, file, name } );

export const setFileLocale = ( key, locale ) => ( {
    type: types.PRIVACY__SET_FILE_LOCALE,
    key,
    locale
} );

export const removeFile = key => ( { type: types.PRIVACY__REMOVE_FILE, key } );

export const setPrivacyValue = ( name, value ) => ( {
    type: types.PRIVACY__SET_PRIVACY_VALUE,
    name,
    value
} );

export const savePrivacyFiles = ( id, body ) => dispatch =>
    apiPostPrivacyFiles( id, body ).then( () => dispatch( getPrivacy( id ) ) );
